import { useRouteMatch } from 'react-router-dom';
import { usePageTitle } from '../../usePageTitle';
import { useMemo } from 'react';
import { NAVBAR_ITEMS, ROUTES_WITH_TITLE } from '../../../constants/navbar';

export const useNavbarTitle = () => {
  const { path } = useRouteMatch();
  const shouldShowButton = ROUTES_WITH_TITLE.includes(path);
  const title = usePageTitle();

  return useMemo(() => {
    return shouldShowButton
      ? {
          item: NAVBAR_ITEMS.TITLE,
          itemConfig: title,
        }
      : null;
  }, [shouldShowButton, title]);
};
